import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  const rows = [{
    label: 'Contenido',
    base: '6 tomos + 4 bonos',
    experto: '6 tomos + 4 bonos + Kit de implementación y certificación'
  }, {
    label: 'Acceso',
    base: 'Acceso Inmediato',
    experto: 'Acceso Inmediato'
  }, {
    label: 'Garantía',
    base: 'Garantía 7 días',
    experto: 'Garantía 7 días'
  }, {
    label: 'Gestión',
    base: '❌ Sin sistema de gestión',
    experto: '✅ Planificador anual mes a mes'
  }, {
    label: 'Seguimiento',
    base: '❌ Sin tablero de seguimiento',
    experto: '✅ Tablero diario, semanal, mensual y anual'
  }, {
    label: 'Familias',
    base: '❌ Sin kit de familias',
    experto: '✅ 10 documentos + 20 posts para redes'
  }, {
    label: 'Certificados',
    base: '❌ Sin certificados',
    experto: '✅ Sistema completo de certificación de alumnos'
  }, {
    label: 'Talleres',
    base: '❌ Sin talleres docentes',
    experto: '✅ 3 talleres con guión para capacitar colegas'
  }, {
    label: 'Portfolio',
    base: '❌ Sin portfolio',
    experto: '✅ Portfolio profesional ambiental en 7 secciones'
  }];
  return <section className="py-20 bg-[#14301f] border-t-4 border-[#c8971b] text-[#f5efe1]" data-id="element-59">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-60">
        <div className="mb-10" data-id="element-61">
          <p className="text-[#e7c766] font-bold uppercase tracking-wider mb-4" data-id="element-62">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="dark" className="scale-110" data-id="element-63" />
        </div>

        <h3 className="text-2xl font-black mb-8 font-[Merriweather,_serif] text-[#f5efe1]" data-id="element-64">
          RESUMEN FINAL
        </h3>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-65">
          <div className="min-w-[600px] max-w-3xl mx-auto" data-id="element-66">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4 items-end" data-id="element-67">
              <div data-id="element-68"></div>
              <div className="font-bold text-[#d8d0bd] uppercase text-sm tracking-wider text-center" data-id="element-69">
                🌿 MEGAPACK GESTIÓN AMBIENTAL LISTO™
              </div>
              <div className="font-bold text-[#e7c766] uppercase text-sm tracking-wider text-center flex items-center justify-center gap-1" data-id="element-70">
                ⭐ MEGAPACK + NIVEL EXPERTO
              </div>
            </div>

            <div className="space-y-2" data-id="element-71">
              <div className="grid grid-cols-3 gap-4 bg-[#1e4230]/80 rounded-xl p-4 items-center border border-[#2f6b47]" data-id="element-72">
                <div className="text-[#a9b8ab] font-medium text-sm" data-id="element-73">Precio</div>
                <div className="text-[#f5efe1] font-bold text-center" data-id="element-74">
                  $19.990 ARS
                </div>
                <div className="text-[#e7c766] font-bold text-center text-lg" data-id="element-75">
                  $27.990 ARS
                </div>
              </div>
              {rows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-[#1e4230]/60 rounded-xl p-4 items-center border border-[#2f6b47]/60" data-id="element-76">
                  <div className="text-[#a9b8ab] font-medium text-sm" data-id="element-77">
                    {row.label}
                  </div>
                  <div className="text-[#f5efe1] font-medium text-center text-sm" data-id="element-78">
                    {row.base}
                  </div>
                  <div className="text-[#f5efe1] font-medium text-center text-sm" data-id="element-79">
                    {row.experto}
                  </div>
                </div>)}
              <div className="grid grid-cols-3 gap-4 bg-transparent p-4 items-center" data-id="element-80">
                <div data-id="element-81"></div>
                <div className="text-center" data-id="element-82">
                  <a href="https://emprendepackcentral.store/cart/48009126445250:1" target="_blank" rel="noopener noreferrer" data-id="element-83">
                    <Button size="sm" variant="secondary" className="w-full text-xs" data-id="element-84">
                      🔥 QUIERO MI MEGAPACK
                    </Button>
                  </a>
                </div>
                <div className="text-center" data-id="element-85">
                  <a href="https://emprendepackcentral.store/cart/48009128116418:1" target="_blank" rel="noopener noreferrer" data-id="element-86">
                    <Button size="sm" variant="premium" className="w-full text-xs" data-id="element-87">
                      ⚡ MEGAPACK + NIVEL EXPERTO
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-[#d8d0bd] font-medium" data-id="element-88">
          <div className="flex items-center gap-1.5" data-id="element-89">
            <Lock className="w-4 h-4 text-[#e7c766]" data-id="element-90" />
            <span data-id="element-91">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-92">
            <Zap className="w-4 h-4 text-[#e7c766]" data-id="element-93" />
            <span data-id="element-94">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-95">
            <Shield className="w-4 h-4 text-[#e7c766]" data-id="element-96" />
            <span data-id="element-97">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-98">
            <CreditCard className="w-4 h-4 text-[#e7c766]" data-id="element-99" />
            <span data-id="element-100">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}